import * as React from 'react';
import { useBreakpoint } from 'gatsby-plugin-breakpoints';
import { Link } from 'gatsby';

// data
const links = [
  {
    text: 'Contact',
    href: '/contact',
  },
  {
    text: 'Privacy',
    href: '/privacy',
  },
  {
    text: 'Terms',
    href: '/terms',
  },
];

// styles
const footerStyles = {
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  marginTop: 10,
  height: 80,
  backgroundColor: '#3a7a68',
  color: '#fff',
  padding: '5px 0px 10px 0px',
  fontSize: 14,
  minWidth: 315,
};

// markup
const Footer = () => {
  const breakpoints = useBreakpoint(),
    fontSize = breakpoints.isMobile ? 12 : 16;

  return (
    <footer style={{ ...footerStyles, fontSize }}>
      <div style={{ display: 'flex',
    alignItems: 'center' }}>
        {links.map((link, index) => (
          <div key={index} style={{ display: 'flex', alignItems: 'center' }}>
            <Link style={{ margin: '0px 20px 10px 20px' }} to={link.href}>
              {link.text}
            </Link>
            {index !== links.length - 1 && <span style={{ fontSize: 27, lineHeight: 1, margin: '0px 0px 14px 0px' }}>·</span>}
          </div>
        ))}
      </div>
      © 2024 Drakom Development, LLC. All rights reserved.
    </footer>
  );
};

export default Footer;
